// extracted by mini-css-extract-plugin
export default {"socialLinks":"SocialLinks_socialLinks__RCg2E","yellow":"SocialLinks_yellow__LDRJ9"};